import createElement from '../utils/create-element';
import preloadText from './preload-text';
import messages from '../messages/common';
import Init from './form/init';
import Network from '../components/network';
import Uploader from './uploader/uploader';
import TwoUploader from './uploader/two-uploader';

class FormContent {
    LOAD_LINK = 'index.php?route=module/simple_forms/loader';
    name;
    data = {};
    activeModal;
    messages;
    resultingFormList;
    uploader;
    twoUploader;

    constructor() {
        this.selectors = {
            elemCall: '[data-content-form]',
            content: '.form-content',
            loader: '.loader',
        };
        this.messages = messages();
        this.resultingFormList = new Map();
        this.uploader = Uploader.run();
        this.twoUploader = TwoUploader.run();

        this.render().then(() => {
            this.resultingFormList.clear();
        });
    }

    static run() {
        return new FormContent();
    }

    /**
     * Set form name
     * @param {Object} elem
     */
    setName(elem) {
        this.name = null;
        let name = elem.dataset.contentForm;

        if (name) {
            this.name = name;
        }
    }

    /**
     * Set form data
     * @param {Object} elem
     */
    setData(elem) {
        let dataSet = elem.dataset;
        this.data = Object.assign({}, dataSet);
    }

    /**
     * Get form data
     * @returns {{name, location: (string|*)}}
     */
    getData() {
        const route = document.getElementById('route');
        const routeVal = route ? route.value : false;

        return Object.assign({
            name: this.name,
            location: window.location.href,
            route: routeVal,
        }, this.data);
    }

    /**
     * Insert html form
     * @param {string} html
     * @returns {Promise<void>}
     */
    async insertHtml(html) {
        this.activeModal.innerHTML = html;
    }

    /**
     * Show form error
     * @returns {Promise<void>}
     */
    async showError() {
        this.activeModal.innerHTML = this.messages.textLoadError;
    }

    /**
     * Render html form or error
     * @param {Object} result - Response form
     * @param {boolean} result.error - Status error
     * @param {string} result.html - Form html
     * @param {Object} result.formDate - Data form info
     * @param {string} elemName - Name form
     * @returns {Promise<void>}
     */
    async renderResultForm(result, elemName) {
        let {error, html, formData = {}} = result;

        if (error === false) {
            if (!this.resultingFormList.has(elemName)) {
                this.resultingFormList.set(elemName, result);
            }

            await this.insertHtml(html).then(() => {
                Init.run({
                    typeName: 'base',
                    data: {
                        modal: Object.assign({}, this),
                        formData,
                    },
                });
            });
        } else {
            await this.showError();
        }
    }

    /**
     * Load form
     * @returns {Promise<void>}
     */
    async render() {
        const contentForms = document.querySelectorAll(this.selectors.elemCall);

        if (contentForms.length === 0) {
            return;
        }

        for await (const item of contentForms) {
            this.setName(item);

            if (!this.name) {
                return;
            }

            this.setData(item);
            this.activeModal = createElement(preloadText());
            item.append(this.activeModal);

            if (this.resultingFormList.has(this.name)) {
                await this.renderResultForm(this.resultingFormList.get(this.name), this.name);
            } else {
                await Network.call({
                    link: this.LOAD_LINK,
                    data: this.getData(),
                    method: 'POST',
                }).then(async (r) => {
                    await this.renderResultForm(r, this.name);
                });
            }
        }
    }

    /**
     * Destroy in modal
     * @param {HTMLFormElement} form
     */
    destroy = (form) => {
        const uploadBox = form.querySelector(this.uploader.wrapBoxSelector);

        if (uploadBox) {
            uploadBox.innerHTML = '';
        }

        const twoUploaderBox = form.querySelector(this.twoUploader.wrapBoxSelector);

        if (twoUploaderBox) {
            twoUploaderBox.innerHTML = '';
            const moreBox = form.querySelector(this.twoUploader.moreSelector);

            if (moreBox) {
                moreBox.style.display = 'none';
            }
        }
    };
}

export default FormContent;
